<template>
  <div
    class="modal-dialog BootstrapModal d-flex"
    :class="{ normalModal, removeOverflow }"
    id="bootstrap-modal"
  >
    <div class="modal-content">
      <div class="modal-header" :class="headerClass">
        <div>
          <h5 v-if="!removeTitle" class="modal-title">
            <slot name="title"></slot>
          </h5>

          <slot name="bootstrap-modal-header-top">
            <portal-target :name="portalTarget" />
          </slot>
        </div>
        <div class="d-flex algn-items-center">
          <portal-target :name="portalTargetClose" />
          <button
            v-if="!removeCloseIcon"
            type="button"
            class="close-modal"
            id="close-modal"
            data-dismiss="modal"
            aria-label="Close"
            @click="$emit('close')"
          >
            <slot name="close"> Afsluiten </slot>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-body d-flex" :class="{ removePadding }">
        <slot></slot>
      </div>
      <div v-if="!disableButton" class="modal-footer">
        <span></span>

        <slot name="slot-options">
          <button
            type="button"
            class="btn btn-primary"
            id="submit-button"
            @click="$emit('save')"
          >
            <slot name="save"> Opslaan </slot>
          </button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    removeOverflow: Boolean,
    removePadding: Boolean,
    removeTitle: Boolean,
    removeCloseIcon: Boolean,
    headerClass: [String, Boolean],

    portalTarget: {
      type: String,
      default: "bootstrap-modal-header",
    },
    portalTargetClose: {
      type: String,
      default: "bootstrap-modal-header-close",
    },

    normalModal: {
      type: Boolean,
      default: true,
    },
    disableButton: {
      type: Boolean,
      required: false,
    },
  },
  mounted() {
    window.addEventListener("keydown", this.keydown, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.keydown);
  },
  methods: {
    keydown({ key }) {
      if (key === "Escape") this.$parent.$emit("close");
    },
  },
};
</script>

<style>
.Modals {
  z-index: 500 !important;
}
</style>

<style scoped>
.BootstrapModal {
  max-width: unset;
  margin-top: 0px;
  z-index: 0 !important;
}

.normalModal {
  margin-top: 30px;
}

.normalModal {
  z-index: 11050 !important;
}

.modal-content {
  max-height: 100vh;
  overflow: auto !important;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.removeOverflow .modal-content {
  overflow: initial !important;
  max-height: initial;
}

.modal-dialog {
  overflow: visible;
}

@media (min-width: 1200px) {
  .modal-content {
    overflow: initial;
  }
}

.modal-header {
  display: flex !important;
  align-items: center !important;
  border-bottom: 1px solid var(--black-20) !important;
}

.modal-header,
.modal-footer,
.modal-body {
  padding: 12px 15px !important;
}

.modal-body {
  padding-left: 24px !important;
  padding-right: 24px !important;
}

.modal-footer {
  padding-top: 0px !important;
}

.close-modal {
  filter: brightness(1);
  color: var(--black-70);
  transition-duration: 0.15s;
}

.close-modal:hover {
  filter: brightness(0.5) !important;
}

.modal-title {
  font-size: 1.1825em !important;
}

.removePadding {
  padding-top: 0px;
  padding: 0px !important;
}

.modal-body > div {
  flex-basis: 100%;
  flex-grow: 1;
}
</style>
